/* ------------------------------------------------
* 右边悬浮窗口
--------------------------------------------------*/
//底部按钮显示和隐藏
$(window).scroll(function () {
    if ($(window).scrollTop() > 10) {
        $(".scrollTop").fadeIn(500);
    } else {
        $(".scrollTop").fadeOut(500);
    }
});

$(function () {
    //点击返回顶部
    $(".scrollTop").click(function () {
        $('body,html').animate({
            scrollTop: 0
        }, 500);
    });
})